import { Tracking } from "./Tracking";
import { ListName, ListPageType, UniversityCardClickEcommerceTrackingData } from "@studyportals/datalake-event-tracker";
import { injectable } from "inversify";
import { ErrorReporter } from "@/infrastructure/ErrorReporter";

@injectable()
export class ClickTracking extends Tracking {

	public constructor(errorReporter: ErrorReporter) {
		super(errorReporter);
	}

	public track(id: number, position: number): void {
		try {
			const data = new UniversityCardClickEcommerceTrackingData(
				id,
				ListPageType.SEARCH,
				ListName.UNIVERSITY_SEARCH_PAGE,
				position
			);
			this.tracker.trackUniversityCardClick(data);
		} catch (error) {
			this.errorReporter.report(JSON.stringify(error));
		}
	}
}
